(() => {
  const sections = document.querySelectorAll('[data-recommended-product-grid]');

  const mountCarousels = (root) => {
    if (typeof Splide === 'undefined') return;

    root.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
      new Splide(carousel, {
        type: 'slide',
        perPage: 1,
        fixedWidth: '70vw',
        gap: 'var(--page-margin)',
        padding: {
          left: 'var(--page-margin)',
          right: 'var(--page-margin)'
        },
        arrows: false,
        pagination: false,
        drag: true,
        snap: true,
        speed: 500,
        focusableNodes: 'a, button, textarea, input, select, iframe, .jdgm-widget a',
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
        mediaQuery: 'min',
        breakpoints: {
          551: {
            destroy: true
          }
        }
      }).mount();
    });
  };

  const load = async (section) => {
    const container = section.querySelector('[data-recommended-products]');
    const url = container && container.dataset.url;
    if (!url) return;

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(response.status);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const recommended = doc.querySelector('[data-recommended-products]');
      container.innerHTML = recommended ? recommended.innerHTML : '';
    } catch (error) {
      container.innerHTML = '';
    }

    const hasProducts = container.querySelector('[data-product-carousel]');
    if (!hasProducts && !(window.Shopify && Shopify.designMode)) {
      section.hidden = true;
      return;
    }

    mountCarousels(container);
  };

  if (!('IntersectionObserver' in window)) {
    sections.forEach(load);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        load(entry.target);
      });
    },
    { rootMargin: '200px' }
  );

  sections.forEach((section) => observer.observe(section));
})();
